import { useState } from 'react';

export interface TenantDialog {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

/**
 * Open/close state for the segment tenant-selection dialog. EditSegmentPage calls
 * this once and shares `open` with the header trigger (SegmentTenantSelectionControl)
 * and the draft banner's "Sync to tenants" action, then conditionally mounts
 * SegmentTenantSelectionDialog while `isOpen` so it starts from fresh state each open.
 */
export function useTenantDialog(): TenantDialog {
  const [isOpen, setIsOpen] = useState(false);
  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };
}
